import { getRequest, postRequest } from '@bo-apis/axios';

const getDeliveryList = ({ searchForm, pageable }) =>
  postRequest({
    url: 'api/v1/po/delivery/get-delivery-list',
    params: { ...pageable },
    data: { ...searchForm },
  });

const getDeliveryCount = ({ searchForm }) =>
  postRequest({
    url: 'api/v1/po/delivery/get-delivery-count',
    data: { ...searchForm },
  });

const getDeliveryDetail = (deliveryNumber) =>
  getRequest({
    url: 'api/v1/po/delivery/get-detail',
    params: { deliveryNumber },
  });

const getDeliveryListByOrderNo = (orderNo) =>
  getRequest({
    url: 'api/v1/po/delivery/get-delivery-list',
    params: { orderNo },
  });

const getDeliveryListByDeliveryNo = (deliveryList) =>
  postRequest({
    url: 'api/v1/po/delivery/get-delivery-list-by-delivery-no',
    data: [...deliveryList],
  });

const getVendorParcelCompanyList = (deliveryList) =>
  postRequest({
    url: 'api/v1/po/delivery/get-vendor-parcel-company-list',
    data: [...deliveryList],
  });

const getOrderStatusByOrder = (orderNo, orderDetailNo) =>
  getRequest({
    url: 'api/v1/po/delivery/get-order-status-date',
    params: { orderNo, orderDetailNo },
  });

const postForceDeliveryDirection = (orderNumberList) =>
  postRequest({
    url: 'api/v1/po/delivery/force-delivery-direction',
    data: orderNumberList,
  });

const postShipmentDirection = (shipmentDirectionList) =>
  postRequest({
    url: 'api/v1/po/delivery/shipment-direction',
    data: shipmentDirectionList,
  });

const postShipmentFinish = (shipmentFinishList) =>
  postRequest({
    url: 'api/v1/po/delivery/shipment-finish',
    data: shipmentFinishList,
  });

const postForceShipmentFinish = (shipmentFinishList) =>
  postRequest({
    url: 'api/v1/po/delivery/force-shipment-finish',
    data: shipmentFinishList,
  });

const postForceDeliveryFinish = (deliveryFinishList) =>
  postRequest({
    url: 'api/v1/po/delivery/force-delivery-finish',
    data: deliveryFinishList,
  });

const postForceTradeFinish = (deliveryFinishList) =>
  postRequest({
    url: 'api/v1/po/delivery/force-trade-finish',
    data: deliveryFinishList,
  });

const processInvoiceExcelUpload = (invoiceExcelUploadList) =>
  postRequest({
    url: 'api/v1/po/delivery/upload-invoice/excel',
    data: invoiceExcelUploadList,
  });
export default {
  getDeliveryList,
  getDeliveryCount,
  getDeliveryDetail,
  getDeliveryListByDeliveryNo,
  getDeliveryListByOrderNo,
  getVendorParcelCompanyList,
  getOrderStatusByOrder,
  postForceDeliveryDirection,
  postShipmentDirection,
  postShipmentFinish,
  postForceShipmentFinish,
  postForceDeliveryFinish,
  postForceTradeFinish,
  processInvoiceExcelUpload,
};
